export const SESSION_RESET = "SESSION_RESET";
export const SESSION_SET_ERROR = "SESSION_SET_ERROR";
export const SESSION_SET_ITEMS = "SESSION_SET_ITEMS";
export const SESSION_TOGGLE_LOADING = "SESSION_TOGGLE_LOADING";
